import type { TypedMyBrandMapCard } from './-MyBrandMapCard';
import RawMyBrandMapCard from './MyBrandMapCard.vue';
export * from './-MyBrandMapCard';
export const MyBrandMapCard = RawMyBrandMapCard as typeof TypedMyBrandMapCard;
